import * as THREE from 'three';
import lifegameVert from "../glsl/lifegame.vert";
import lifegameFrag from "../glsl/lifegame.frag";
import { QTreeDispQuads } from '../quads/QTreeDispQuads';
import { ShaderMaterial } from 'three';
import { QTreeRect } from '../myP5/drawer/QTreeRect';
import { ColorTex } from './ColorTex';


export class CAVisualizer extends THREE.Mesh{

    //quads    :QTreeQuads;
    mat         :ShaderMaterial;
    colorTex    :ColorTex;

    constructor(planeWidth:number,textureWidth:number,p5width:number){

        let plane = new THREE.PlaneGeometry(
            128,128//planeWidth,planeHeight
        );

        let material = new THREE.ShaderMaterial({
          uniforms: {
            textureLifeGame: {value: null},
            textureLifeGame2: {value: null},
            ruleTex:{value:null},//ruleTex.dataTex},
            colorTex:{value:null},
            areaTex: {value: null},
            areaTexSize: {value: new THREE.Vector2(
                p5width,p5width
            )},
            counter: {value: 0},
            planeSize: {value: new THREE.Vector2(planeWidth, planeWidth)},
            textureSize: {value: new THREE.Vector2(textureWidth, textureWidth)}
          },
          vertexShader: lifegameVert,
          fragmentShader: lifegameFrag,
          side: THREE.DoubleSide
        });
        super(plane, material);

        this.mat = material;

        //this.quads = new QTreeQuads();
        //this.add(this.quads);
        //this.lineQuad = new TQuads();
        //this.lineQuad.visible=false;
        //this.add(this.lineQuad);

        this.colorTex = new ColorTex();
        this.mat.uniforms.colorTex.value = this.colorTex.tex;

    }

    public reset(rects:QTreeRect[]){
        
        //this.quads.init(rects);

    }

    public update(tex1:THREE.Texture,tex2:THREE.Texture,areaTex:THREE.Texture){
        
        this.mat.uniforms.textureLifeGame.value = tex1;
        this.mat.uniforms.textureLifeGame2.value = tex2;
        this.mat.uniforms.areaTex.value = areaTex;

    }

}